import theme from './theme'
import GlobalStyle from './GlobalStyle'

export { theme, GlobalStyle }
